<div class="table-layout">
  <ion-grid class="p-0 h-100">
    <ion-row class="p-0 mb-20">
      <ion-col class="p-0 display-space-between" size="12">
        <div>
          <ion-label class="font_bold black_color">{{headerName}} ({{gridData.totalCount}})</ion-label>
        </div>
        <div class="display-end p-0">
          <button *ngIf="headerName == 'Skip'" type="button" class="back_btn fs-14 fs_12ForMobile mr-40 d-flex"
            (click)="downloadSkippedEmp()">
            <span class="material-icons mr-5">download</span>Download</button>
          <img [mat-dialog-close] src="././assets/icon/close_icon.png" class="cp fixed">
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="p-0 mb-10">
      <ion-col class="p-0">
        <div>
          <table class="hover" *ngIf="this.moduleName != 'competencyImport'">
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_regular cl-black" *ngFor="let item of gridData.columnInfo">
                  <div class="verticle-center icon-style">{{item.label}}
                    <!-- <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="onSortAssending(item)">arrow_drop_up</i>
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="onSortDesending(item)">arrow_drop_down</i>
                    </div> -->
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white" *ngIf="renderData.length !== 0">
              <tr *ngFor="let item of renderData;let i=index">
                <ng-container *ngFor="let innerItem of item">
                  <td *ngIf="innerItem.key !== 'id'" class="fs-14 fs_12ForMobile font_regular">{{innerItem.value}}</td>
                </ng-container>
              </tr>
            </tbody>
          </table>
          <table class="hover" *ngIf="this.moduleName == 'competencyImport'">
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">Dept/Function</th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">Band/Grade</th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">Competency Name</th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">Competency Defination</th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">WT</th>
                <th *ngIf="colName == 'Skip'"  class="fs-14 fs_12ForMobile font_bold cl-black">Reason</th>
              </tr>
            </thead>
            <tbody class="bg-white" *ngIf="competencyemployee.length !== 0">
              <ng-container *ngFor="let item of competencyemployee; let empIndex = index">
                <ng-container *ngFor="let competency of item.competencyMasterlist; let i = index">
                  <tr>
                    <ng-container *ngIf="i === 0">
                      <td class="fs-14 fs_12ForMobile font_regular" [attr.rowspan]="item.competencyMasterlist.length">
                        {{ item.functionName }}
                      </td>
                      <td class="fs-14 fs_12ForMobile font_regular" [attr.rowspan]="item.competencyMasterlist.length">
                        {{ item.band }}
                      </td>
                    </ng-container>
                    <td class="fs-14 fs_12ForMobile font_regular">{{ competency.competencyName }}</td>
                    <td class="fs-14 fs_12ForMobile font_regular">{{ competency.competencyDefination }}</td>
                    <td class="fs-14 fs_12ForMobile font_regular">{{ competency.weightageNo }}</td>
                    <th *ngIf="colName == 'Skip'" class="fs-14 fs_12ForMobile font_bold cl-black">{{ item.reason }}</th>
                  </tr>
                </ng-container>
                <tr class="total-row">
                  <td colspan="4" class="fs-14 fs_12ForMobile font_bold cl-black text-right"></td>
                  <td class="fs-14 fs_12ForMobile font_bold cl-black">Total :<span class="orangecolor">{{getTotalWeight(item)}}</span>
                  </td>
                  <td *ngIf="colName == 'Skip'" colspan="1" class="fs-14 fs_12ForMobile font_bold cl-black text-right"></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ion-col>
      <ion-col size="12" class="p-0 mt-20">
        <!-- <div class="bg-white text-center font_medium" *ngIf="competencyemployee.length === 0">No Data Found</div> -->
      </ion-col>
    </ion-row>
  </ion-grid>
</div>